export default {
    computed: {
        price: function(){
            return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF',minimumFractionDigits: 0,maximumFractionDigits: 0}).format(this.tripData.startpreis);
        },
        url: function () {
            if (this.tripData.overrides && this.tripData.overrides.buttonLink) {
                return this.tripData.overrides.buttonLink;
            }
            if (this.tripData.titel) return '/reise/' + this.sanitizeTitle(this.tripData.tdbez) + '-' + this.tripData.code;
            return '/reise/' + this.tripData.code;
        },
        target: function () {
            if (this.tripData.overrides && this.tripData.overrides.buttonTarget) {
                return this.tripData.overrides.buttonTarget;
            }
            return ''
        },
        button: function () {
            if (this.tripData.overrides && this.tripData.overrides.buttonText) {
                return this.tripData.overrides.buttonText;
            }
            if (this.tripData && this.tripData.ausgebucht === true) {
                return 'Ausgebucht';
            }
            if (this.tripData && this.tripData.anzahlabreisedaten === 0) {
                return 'Reise in Planung';
            }
            if (this.tripData) {
                if(this.tripData.dauer == 1){
                    return this.tripData.dauer + " Tag ab <strong>" + this.price + ".–</strong>";
                } else {
                    return this.tripData.dauer + " Tage ab <strong>" + this.price + ".–</strong>";
                }

            }
        },
        concatCountries: function () {
            if (this.tripData) {
                var countryNames = [];
                if (this.tripData.laender) this.tripData.laender.forEach(function (c) {
                    countryNames.push(c.bezeichnung);
                })
                return countryNames.join(', ');
            }
        },
        isKoenigsklasse: function () {
            return (this.tripData.busse == 'koenig') || (this.tripData.busse == 'koenig_komfort')  || (this.tripData.overrides && this.tripData.overrides.isKoenigsklasse);
        },
        isKomfortklasse: function () {
            return (this.tripData.busse == 'komfort') || (this.tripData.busse == 'komfort_koenig')  || (this.tripData.overrides && this.tripData.overrides.isKomfortklasse);
        },
        isGuaranteed: function() {
            return (this.tripData.garantiert) || (this.tripData.overrides && this.tripData.overrides.isGuaranteed);
        },
        isFullyBooked: function() {
            return (this.tripData.ausgebucht) || (this.tripData.overrides && this.tripData.overrides.isFullyBooked);
        }
    },
    mounted(){

    }
};